/*global Tier0 dummy  event referer arcotfccurl TYPE REALMOID AWD TARGET GUID known SUBMITSTATUS SMENC SMLOCALE SMAUTHREASON  SMAGENTNAME METHOD arcotClient */
import React from 'react';
import PropTypes from 'prop-types';
import { Button} from 'adp-react-components';


 class CloseBrowser extends React.Component{


  constructor(props){
    super(props);
    this.state= {

    }

  }
  componentWillMount(){

  }


  render() {
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form fyp">
            <div>
            <p>{this.props.closeBrowserMessage}</p>
            </div>
          { /*  <div className="form-group submit vdl-text-xs-center">

            <Button className="primary">
            Close
            </Button>

            </div>*/ }
            { /* form-group submit vdl-text-xs-center */ }
          </form>

          { /* adp-form */ }
        </div>
        { /* vdl-col-md-12 */ }
      </div>
      /* vdl-row login-form */
    )}

  }
export default CloseBrowser;



// WEBPACK FOOTER //
// ./src/components/utils/close-browser.js